<div class="container my-4">
  <div class="line"></div>
  <h4 class="text-uppercase mt-3" *ngIf="caption">{{caption}}</h4>
</div>
